module.exports = __webpack_public_path__ + "img/photo_1.d146e61f.jpg";